module.exports = __webpack_public_path__ + "img/xitong5.4889a7d7.png";